export default __webpack_public_path__ + "static/media/bg-billet.eeb35121.png";